import script from "./DesktopOverlays.vue?vue&type=script&lang=ts&setup=true"
export * from "./DesktopOverlays.vue?vue&type=script&lang=ts&setup=true"

import "./DesktopOverlays.vue?vue&type=style&index=0&id=4afc6b14&lang=stylus"

const __exports__ = script;

export default __exports__